import * as React from "react";
import { withRouter } from "react-router";

import Nav from "./Nav";
import { default as NavItem } from "./NavItem";

interface LocationProps {
  pathname: string;
  hash: string;
}

const isActive = (to: string, location: LocationProps): boolean => {
  return location && location.pathname === to;
};

const NavContainer = ({ location }) => (
  <Nav>
    <NavItem to="/pages/about" active={isActive("/pages/about", location)}>
      <span className="ic-our">
        <i className="icon-main" />
      </span>{" "}
      Về chúng tôi
    </NavItem>
    <NavItem to="/pages/terms" active={isActive("/pages/terms", location)}>
      <span className="ic-term">
        <i className="icon-main" />
      </span>{" "}
      Điều khoản sử dụng
    </NavItem>
    <NavItem to="/pages/privacy" active={isActive("/pages/privacy", location)}>
      <span className="ic-csbm">
        <i className="icon-main" />
      </span>{" "}
      Chính sách bảo mật
    </NavItem>
    <NavItem to="/pages/order" active={isActive("/pages/order", location)}>
      <span className="ic-qdgd">
        <i className="icon-main" />
      </span>{" "}
      Quy định giao dịch
    </NavItem>
    <NavItem to="/pages/qa" active={isActive("/pages/qa", location)}>
      <span className="ic-qa">
        <i className="icon-main" />
      </span>{" "}
      Q&amp;A
    </NavItem>
  </Nav>
);

export default withRouter(NavContainer);



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/NavContainer.tsx